import { render, staticRenderFns } from "./CompGeneralSwitch.vue?vue&type=template&id=444d6e1f&scoped=true"
import script from "./CompGeneralSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralSwitch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444d6e1f",
  null
  
)

export default component.exports